// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../images/rtc/mic-on.png");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../images/rtc/mic-off.png");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../images/rtc/speaker-on.png");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../images/rtc/speaker-off.png");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../images/rtc/loader.svg");
var ___CSS_LOADER_URL_IMPORT_5___ = require("../images/rtc/audioonly-figma-silhouette.svg");
var ___CSS_LOADER_URL_IMPORT_6___ = require("../images/rtc/audioonly-headset.svg");
var ___CSS_LOADER_URL_IMPORT_7___ = require("../images/rtc/video-disabled.png");
var ___CSS_LOADER_URL_IMPORT_8___ = require("../images/rtc/video-disabled-warning.png");
var ___CSS_LOADER_URL_IMPORT_9___ = require("../images/rtc/audio-off-background.svg");
var ___CSS_LOADER_URL_IMPORT_10___ = require("../images/rtc/video-off.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Copyright (c) 2017 TokBox, Inc.
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 */

/**
 * OT Base styles
 */

/* Root OT object, this is where our CSS reset happens */
.OT_root,
.OT_root * {
  color: #ffffff;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: baseline;
}

/**
 * Specific Element Reset
 */

.OT_root h1,
.OT_root h2,
.OT_root h3,
.OT_root h4,
.OT_root h5,
.OT_root h6 {
  color: #ffffff;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  font-weight: bold;
}

.OT_root header {

}

.OT_root footer {

}

.OT_root div {

}

.OT_root section {

}

.OT_root video {

}

.OT_root button {

}

.OT_root strong {
  font-weight: bold;
}

.OT_root em {
  font-style: italic;
}

.OT_root a,
.OT_root a:link,
.OT_root a:visited,
.OT_root a:hover,
.OT_root a:active {
  font-family: Arial, Helvetica, sans-serif;
}

.OT_root ul, .OT_root ol {
  margin: 1em 1em 1em 2em;
}

.OT_root ol {
  list-style: decimal outside;
}

.OT_root ul {
  list-style: disc outside;
}

.OT_root dl {
  margin: 4px;
}

.OT_root dl dt,
.OT_root dl dd {
  float: left;
  margin: 0;
  padding: 0;
}

.OT_root dl dt {
  clear: left;
  text-align: right;
  width: 50px;
}

.OT_root dl dd {
  margin-left: 10px;
}

.OT_root img {
  border: 0 none;
}

/* Modal dialog styles */

/* Modal dialog styles */

.OT_dialog-centering {
  display: table;
  width: 100%;
  height: 100%;
}

.OT_dialog-centering-child {
  display: table-cell;
  vertical-align: middle;
}

.OT_dialog {
  position: relative;

  box-sizing: border-box;
  max-width: 576px;
  margin-right: auto;
  margin-left: auto;
  padding: 36px;
  text-align: center; /* centers all the inline content */

  background-color: #363636;
  color: #fff;
  box-shadow: 2px 4px 6px #999;
  font-family: 'Didact Gothic', sans-serif;
  font-size: 13px;
  line-height: 1.4;
}

.OT_dialog * {
  font-family: inherit;
  box-sizing: inherit;
}

.OT_closeButton {
  color: #999999;
  cursor: pointer;
  font-size: 32px;
  line-height: 36px;
  position: absolute;
  right: 18px;
  top: 0;
}

.OT_dialog-messages {
  text-align: center;
}

.OT_dialog-messages-main {
  margin-bottom: 36px;
  line-height: 36px;

  font-weight: 300;
  font-size: 24px;
}

.OT_dialog-messages-minor {
  margin-bottom: 18px;

  font-size: 13px;
  line-height: 18px;
  color: #A4A4A4;
}

.OT_dialog-messages-minor strong {
  color: #ffffff;
}

.OT_dialog-actions-card {
  display: inline-block;
}

.OT_dialog-button-title {
  margin-bottom: 18px;
  line-height: 18px;

  font-weight: 300;
  text-align: center;
  font-size: 14px;
  color: #999999;
}
.OT_dialog-button-title label {
  color: #999999;
}

.OT_dialog-button-title a,
.OT_dialog-button-title a:link,
.OT_dialog-button-title a:active {
  color: #02A1DE;
}

.OT_dialog-button-title strong {
  color: #ffffff;
  font-weight: 100;
  display: block;
}

.OT_dialog-button {
  display: inline-block;

  margin-bottom: 18px;
  padding: 0 1em;

  background-color: #1CA3DC;
  text-align: center;
  cursor: pointer;
}

.OT_dialog-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.OT_dialog-button-large {
  line-height: 36px;
  padding-top: 9px;
  padding-bottom: 9px;

  font-weight: 100;
  font-size: 24px;
}

.OT_dialog-button-small {
  line-height: 18px;
  padding-top: 9px;
  padding-bottom: 9px;

  background-color: #444444;
  color: #999999;
  font-size: 16px;
}

.OT_dialog-progress-bar {
  display: inline-block; /* prevents margin collapse */
  width: 100%;
  margin-top: 5px;
  margin-bottom: 41px;

  border: 1px solid #4E4E4E;
  height: 8px;
}

.OT_dialog-progress-bar-fill {
  height: 100%;

  background-color: #29A4DA;
}

/* Helpers */

.OT_centered {
  position: fixed;
  left: 50%;
  top: 50%;
  margin: 0;
}

.OT_dialog-hidden {
  display: none;
}

.OT_dialog-button-block {
  display: block;
}

.OT_dialog-no-natural-margin {
  margin-bottom: 0;
}

/* Publisher and Subscriber styles */

.OT_publisher, .OT_subscriber {
  position: relative;
  min-width: 48px;
  min-height: 48px;
}

.OT_publisher .OT_video-element,
.OT_subscriber .OT_video-element {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;

  transform-origin: 0 0;
}

/* Styles that are applied when the video element should be mirrored */
.OT_publisher.OT_mirrored .OT_video-element {
  transform: scale(-1, 1);
  transform-origin: 50% 50%;
}

.OT_subscriber_error {
  background-color: #000;
  color: #fff;
  text-align: center;
}

.OT_subscriber_error > p {
  padding: 20px;
}

/* The publisher/subscriber name/mute background */
.OT_publisher .OT_bar,
.OT_subscriber .OT_bar,
.OT_publisher .OT_name,
.OT_subscriber .OT_name,
.OT_publisher .OT_archiving,
.OT_subscriber .OT_archiving,
.OT_publisher .OT_archiving-status,
.OT_subscriber .OT_archiving-status,
.OT_publisher .OT_archiving-light-box,
.OT_subscriber .OT_archiving-light-box {
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  height: 34px;
  position: absolute;
}

.OT_publisher .OT_bar,
.OT_subscriber .OT_bar {
  background: rgba(0, 0, 0, 0.4);
}

.OT_publisher .OT_edge-bar-item,
.OT_subscriber .OT_edge-bar-item {
  z-index: 1; /* required to get audio level meter underneath */
}

/* The publisher/subscriber name panel/archiving status bar */
.OT_publisher .OT_name,
.OT_subscriber .OT_name {
  background-color: transparent;
  color: #ffffff;
  font-size: 15px;
  line-height: 34px;
  font-weight: normal;
  padding: 0 4px 0 36px;
  letter-spacing: normal;
}

.OT_publisher .OT_archiving-status,
.OT_subscriber .OT_archiving-status {
  background: rgba(0, 0, 0, 0.4);
  top: auto;
  bottom: 0;
  left: 34px;
  padding: 0 4px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  line-height: 34px;
  font-weight: normal;
  letter-spacing: normal;
}

.OT_micro .OT_archiving-status,
.OT_micro:hover .OT_archiving-status,
.OT_mini .OT_archiving-status,
.OT_mini:hover .OT_archiving-status {
  display: none;
}

.OT_publisher .OT_archiving-light-box,
.OT_subscriber .OT_archiving-light-box {
  background: rgba(0, 0, 0, 0.4);
  top: auto;
  bottom: 0;
  right: auto;
  width: 34px;
  height: 34px;
}

.OT_archiving-light {
  width: 7px;
  height: 7px;
  border-radius: 30px;
  position: absolute;
  top: 14px;
  left: 14px;
  background-color: #575757;
  box-shadow: 0 0 5px 1px #575757;
}

.OT_archiving-light.OT_active {
  background-color: #970d13;
  -webkit-animation: OT_pulse 1.3s ease-in;
  -moz-animation: OT_pulse 1.3s ease-in;
  -webkit-animation: OT_pulse 1.3s ease-in;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
}

.OT_mini .OT_bar,
.OT_bar.OT_mode-mini,
.OT_bar.OT_mode-mini-auto {
  bottom: 0;
  height: auto;
}

.OT_mini .OT_name.OT_mode-off,
.OT_mini .OT_name.OT_mode-on,
.OT_mini .OT_name.OT_mode-auto,
.OT_mini:hover .OT_name.OT_mode-auto {
  display: none;
}

.OT_publisher .OT_name,
.OT_subscriber .OT_name {
    left: 10px;
    right: 37px;
    height: 34px;
    padding-left: 0;
}

.OT_publisher .OT_mute,
.OT_subscriber .OT_mute {
    border: none;
    cursor: pointer;
    display: block;
    position: absolute;
    text-align: center;
    text-indent: -9999em;
    background-color: transparent;
    background-repeat: no-repeat;
}

.OT_publisher .OT_mute,
.OT_subscriber .OT_mute {
  right: 0;
  top: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  height: 36px;
  width: 37px;
}

.OT_mini .OT_mute,
.OT_publisher.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold,
.OT_subscriber.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold {
  top: 50%;
  left: 50%;
  right: auto;
  margin-top: -18px;
  margin-left: -18.5px;
  border-left: none;
}

.OT_publisher .OT_mute {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 9px 5px;
}

.OT_publisher .OT_mute.OT_active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 9px 4px;
}

.OT_subscriber .OT_mute {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 8px 7px;
}

.OT_subscriber .OT_mute.OT_active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: 7px 7px;
}

/**
 * Styles for display modes
 *
 * Note: It's important that these completely control the display and opacity
 * attributes, no other selectors should atempt to change them.
 */

/* Default display mode transitions for various chrome elements */
.OT_publisher .OT_edge-bar-item,
.OT_subscriber .OT_edge-bar-item {
  transition-property: top, bottom, opacity;
  transition-duration: 0.5s;
  transition-timing-function: ease-in;
}

.OT_publisher .OT_edge-bar-item.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_mode-off,
.OT_publisher .OT_edge-bar-item.OT_mode-auto,
.OT_subscriber .OT_edge-bar-item.OT_mode-auto,
.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,
.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {
  top: -25px;
  opacity: 0;
}

.OT_publisher .OT_edge-bar-item.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_mode-off {
  display: none;
}

.OT_mini .OT_mute.OT_mode-auto,
.OT_publisher .OT_mute.OT_mode-mini-auto,
.OT_subscriber .OT_mute.OT_mode-mini-auto {
  top: 50%;
}

.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,
.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,
.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto {
  top: auto;
  bottom: -25px;
}

.OT_publisher .OT_edge-bar-item.OT_mode-on,
.OT_subscriber .OT_edge-bar-item.OT_mode-on,
.OT_publisher .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,
.OT_subscriber .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,
.OT_publisher:hover .OT_edge-bar-item.OT_mode-auto,
.OT_subscriber:hover .OT_edge-bar-item.OT_mode-auto,
.OT_publisher:hover .OT_edge-bar-item.OT_mode-mini-auto,
.OT_subscriber:hover .OT_edge-bar-item.OT_mode-mini-auto {
  top: 0;
  opacity: 1;
}

.OT_mini .OT_mute.OT_mode-on,
.OT_mini:hover .OT_mute.OT_mode-auto,
.OT_mute.OT_mode-mini,
.OT_root:hover .OT_mute.OT_mode-mini-auto {
  top: 50%;
}

.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,
.OT_publisher:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,
.OT_subscriber:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto {
  top: auto;
  bottom: 0;
  opacity: 1;
}


/* Contains the video element, used to fix video letter-boxing */
.OT_widget-container {
  position: absolute;
  background: linear-gradient(60.08deg, #333333 0%, #1A1A1A 100%);
  overflow: hidden;
}

.OT_hidden-audio {
  position: absolute !important;
  height: 1px !important;
  width: 1px !important;
}

/* Load animation */
.OT_root .OT_video-loading {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: none;

  background-color: rgba(0, 0, 0, .75);
}

.OT_root .OT_video-loading .OT_video-loading-spinner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  position: absolute;
  width: 32px;
  height: 32px;
  left: 50%;
  top: 50%;
  margin-left: -16px;
  margin-top: -16px;
  animation: OT_spin 2s linear infinite;
}
@keyframes OT_spin {
  100% {
    transform: rotate(360deg);
  }
}

.OT_publisher.OT_loading .OT_video-loading,
.OT_subscriber.OT_loading .OT_video-loading {
  display: block;
}

.OT_publisher.OT_loading .OT_video-element,
.OT_subscriber.OT_loading .OT_video-element {
  /*display: none;*/
}

.OT_video-centering {
  display: table;
  width: 100%;
  height: 100%;
}

.OT_video-container {
  display: table-cell;
  vertical-align: middle;
}

.OT_video-poster {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: none;

  opacity: 1.0;

  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: auto 55%;
}

.OT_fit-mode-cover .OT_video-element {
  object-fit: cover;
}

/* Workaround for iOS freezing issue when cropping videos */
/* https://bugs.webkit.org/show_bug.cgi?id=176439 */
@media only screen
  and (orientation: portrait) {
  .OT_subscriber.OT_ForceContain.OT_fit-mode-cover .OT_video-element {
    object-fit: contain !important;
  }
}

.OT_fit-mode-contain .OT_video-element {
  object-fit: contain;
}

.OT_fit-mode-cover .OT_video-poster {
  background-position: center;
}

.OT_fit-mode-contain .OT_video-poster {
  background-position: center;
}

.OT_audio-level-meter {
  position: absolute;
  width: 25%;
  max-width: 224px;
  min-width: 21px;
  top: 0;
  right: 0;
  overflow: hidden;
}

.OT_audio-level-meter:before {
  /* makes the height of the container equals its width */
  content: '';
  display: block;
  padding-top: 100%;
}

.OT_audio-level-meter__audio-only-img {
  position: absolute;
  top: 22%;
  right: 15%;
  width: 40%;

  opacity: .7;

  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center;
}

.OT_audio-level-meter__audio-only-img:before {
  /* makes the height of the container equals its width */
  content: '';
  display: block;
  padding-top: 100%;
}

.OT_audio-level-meter__value {
  will-change: transform;
  position: absolute;
  top: -100%;
  right: -100%;
  width: 200%;
  height: 200%;
  transform: scale(0);
  border-radius: 50%;
  background-image: radial-gradient(circle, rgba(151, 206, 0, 1) 0%, rgba(151, 206, 0, 0) 100%);
}

.OT_audio-level-meter.OT_mode-off {
    display: none;
}

.OT_audio-level-meter.OT_mode-on,
.OT_audio-only .OT_audio-level-meter.OT_mode-auto {
  display: block;
}

.OT_audio-only.OT_publisher .OT_video-element,
.OT_audio-only.OT_subscriber .OT_video-element {
  display: none;
}


.OT_video-disabled-indicator {
  opacity: 1;
  border: none;
  display: none;
  position: absolute;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: bottom right;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 3px;
  right: 3px;
}

.OT_video-disabled {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 33px auto;
}

.OT_video-disabled-warning {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 33px auto;
}

.OT_video-disabled-indicator.OT_active {
  display: block;
}

.OT_audio-blocked-indicator {
  opacity: 1;
  border: none;
  display: none;
  position: absolute;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.OT_audio-blocked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: 90px auto;
}

.OT_container-audio-blocked {
  cursor: pointer;
}

.OT_container-audio-blocked.OT_mini .OT_edge-bar-item {
  display: none;
}

.OT_container-audio-blocked .OT_mute {
  display: none;
}

.OT_audio-blocked-indicator.OT_active {
  display: block;
}

.OT_video-unsupported {
  opacity: 1;
  border: none;
  display: none;
  position: absolute;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: 58px auto;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin-top: -30px;
}

.OT_video-unsupported-bar {
  display: none;
  position: absolute;
  width: 192%; /* copy the size of the audio meter bar for symmetry */
  height: 192%;
  top: -96% /* half of the size */;
  left: -96%;
  border-radius: 50%;

  background-color: rgba(0, 0, 0, .8);
}

.OT_video-unsupported-img {
  display: none;
  position: absolute;
  top: 11%;
  left: 15%;
  width: 70%;
  opacity: .7;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
}

.OT_video-unsupported-img:before {
  /* makes the height of the container 93% of its width (90/97 px) */
  content: '';
  display: block;
  padding-top: 93%;
}

.OT_video-unsupported-text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  margin-top: 40px;
}

.OT_video-unsupported.OT_active {
  display: block;
}

.OT_mini .OT_video-unsupported,
.OT_micro .OT_video-unsupported {
  position: absolute;
  width: 25%;
  max-width: 224px;
  min-width: 21px;
  top: 0;
  left: 0;
  overflow: hidden;
  background: none;
  bottom: auto;
  right: auto;
  margin: auto;
}

.OT_mini .OT_video-unsupported:before,
.OT_micro .OT_video-unsupported:before {
  /* makes the height of the container equals its width */
  content: '';
  display: block;
  padding-top: 100%;
}

.OT_mini .OT_video-unsupported-bar,
.OT_micro .OT_video-unsupported-bar,
.OT_mini .OT_video-unsupported-img,
.OT_micro .OT_video-unsupported-img {
  display: block;
}

.OT_mini .OT_video-unsupported-text,
.OT_micro .OT_video-unsupported-text {
  display: none;
}

.OT_hide-forced {
  display: none;
}

.OT_ModalDialog {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.2);
}

#tb_alert {
  position: fixed;
  width: 570px;
  font-family: "Lucida Grande", Arial;
  top: 50%;
  left: 50%;
  margin-top: -75px;
  margin-left: -285px;
}

#tb_alert * {
  box-sizing: border-box;
}

#tb_alert .OT_alert {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: #333;
  position: relative;
  padding: 30px;
  overflow: visible;
  margin-left: 70px;
  border-bottom-color: rgba(255, 255, 255, 0.1);
  border-left-color: rgba(255, 255, 255, 0.1);

  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));

  background-image: -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));

  background-size: 4px 4px;
  background-position: 0 0, 2px 2px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

#tb_alert .OT_alert-exclamation {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);

  margin: -1px 0;

  font-family: MS Trebuchet;
  font-weight: bold;
  font-size: 60px;
  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);

  color: white;
  width: 65px;
  position: absolute;
  padding: 42px 0;
  text-align: center;
  left: -70px;
  top: 0;
  bottom: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;

  border-bottom-color: transparent;
  border-left: none;
  border-right: none;
}

.OT_alert-exclamation {
  background-color: #9c1408;
  background-image: linear-gradient(0deg, #dd0c0a 0%, #9c1408 100%);
}

.OT_alert-exclamation.OT_alert-check {
  background-color: #0a8a16;
  background-image: linear-gradient(0deg, #12c722 0%, #0a8a16 100%);
}

#tb_alert .OT_alert-exclamation:after,
#tb_alert .OT_alert-exclamation:before {
  content: " ";
  position: absolute;
  right: -24px;
  top: 40%;
  border: 12px solid transparent;
  border-left-color: #9c1408;
}

#tb_alert .OT_alert-exclamation.OT_alert-check:after,
#tb_alert .OT_alert-exclamation.OT_alert-check:before {
  border-left-color: #0a8a16;
}

#tb_alert .OT_alert-exclamation:before {
  border-left-color: #bc3428;
  top: 39%;
}

#tb_alert .OT_alert-body {
  color: #c8c5c5;
  margin: 0;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);
  font-size: 14px;
  line-height: 1.3em;
}

#tb_alert .continue-text {
  margin-top: 12px
}

#tb_alert > * a {
  color: #a7d8df;
  text-decoration: none;
}

#tb_alert .OT_alert-header {
  font-size: 24px;
  padding-bottom: 5px;
  color: #aaa;
  font-weight: bold;
  position: relative;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);
  margin: 0;
}

#tb_alert .OT_alert-header::before {
  content: attr(data-text);
  position: absolute;
  left: 0;
  color: white;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left top, left bottom,
    from(rgba(0, 0, 0, 1)),
    color-stop(60%, rgba(0, 0, 0, 0)),
    to(rgba(0, 0, 0, 0))
  );
}

#tb_alert .OT_alert-close-button {
  position: absolute;
  right: 8px;
  top: 5px;
  background-color: #000;
  color: #666;
  border: none;
  font-size: 20px;
  /** Hack to bring it up to the proper line top */
  line-height: 14px;
  padding: 0;
  padding-bottom: 3px;
  cursor: pointer;
}

#tb_alert #section-mobile-unsupported-install,
#tb_alert #section-mobile-supported-install,
#tb_alert #section-mobile-upgrade-install {
  width: 200px;
  top: 0px;
  left: 25%;
  margin-top: 0;
  margin-left: 0;
}

@media all and (max-height: 300px) {
  #tb_alert {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: 0;
    margin-top: 0;
  }
  #tb_alert #section-mobile-unsupported-install,
  #tb_alert #section-mobile-supported-install,
  #tb_alert #section-mobile-upgrade-install {
    margin-left: 0;
    margin-top: 10px;
    left: 0;
  }
}

#tb_alert #section-supported-install,
#tb_alert #section-unsupported-install,
#tb_alert #section-upgrade-install,
#tb_alert #section-mobile-unsupported-install,
#tb_alert #section-mobile-supported-install,
#tb_alert #section-mobile-upgrade-install {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/ot.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;EAEE;;AAEF,wDAAwD;AACxD;;EAEE,cAAc;EACd,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;;EAEE;;AAEF;;;;;;EAME,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;;AAExB,wBAAwB;;AAExB;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;;EAElB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB,EAAE,mCAAmC;;EAEvD,yBAAyB;EACzB,WAAW;EACX,4BAA4B;EAC5B,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;;EAEjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;;EAEnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;;EAEjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;;EAErB,mBAAmB;EACnB,cAAc;;EAEd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;;EAEnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB,EAAE,6BAA6B;EACpD,WAAW;EACX,eAAe;EACf,mBAAmB;;EAEnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA,YAAY;;AAEZ;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,kDAAkD;AAClD;;;;;;;;;;EAUE,0BAA0B;EAC1B,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,UAAU,EAAE,iDAAiD;AAC/D;;AAEA,6DAA6D;AAC7D;;EAEE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,UAAU;EACV,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,qCAAqC;EACrC,wCAAwC;EACxC,2CAA2C;EAC3C,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;;;EAGE,SAAS;EACT,YAAY;AACd;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;EAEE,QAAQ;EACR,MAAM;EACN,+CAA+C;EAC/C,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yDAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,yDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE,yDAAmD;EACnD,4BAA4B;AAC9B;;AAEA;EACE,yDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;;;;;EAKE;;AAEF,iEAAiE;AACjE;;EAEE,yCAAyC;EACzC,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;;;;;;EAME,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,QAAQ;AACV;;AAEA;;;;;;EAME,SAAS;EACT,aAAa;AACf;;AAEA;;;;;;;;EAQE,MAAM;EACN,UAAU;AACZ;;AAEA;;;;EAIE,QAAQ;AACV;;AAEA;;;;EAIE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;;AAGA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,oCAAoC;AACtC;;AAEA;EACE,6DAAqD;EACrD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,YAAY;;EAEZ,4BAA4B;EAC5B,yDAAmE;EACnE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D,mDAAmD;AACnD;;EAEE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;;EAEV,WAAW;;EAEX,oEAAqE;AACvE;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6FAA6F;AAC/F;;AAEA;IACI,aAAa;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;EACjC,oBAAoB;EACpB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yDAAuD;EACvD,0BAA0B;AAC5B;;AAEA;EACE,yDAA+D;EAC/D,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,yDAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0DAAkD;EAClD,0BAA0B;EAC1B,oBAAoB;EACpB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW,EAAE,sDAAsD;EACnE,YAAY;EACZ,gCAAgC;EAChC,UAAU;EACV,kBAAkB;;EAElB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,0DAAkD;EAClD,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kEAAkE;EAClE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,uDAAuD;EACvD,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,2CAA2C;;EAE3C,4QAA4Q;;EAE5Q,oRAAoR;;EAEpR,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;;EAE1C,cAAc;;EAEd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;;EAE7C,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;;EAE9B,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;EACzB,iEAAiE;AACnE;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ;;;;;;GAMC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,cAAc;IACd,aAAa;EACf;EACA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,OAAO;EACT;AACF;;AAEA;;;;;;EAME,aAAa;AACf","sourcesContent":["/*!\n * Copyright (c) 2017 TokBox, Inc.\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n */\n\n/**\n * OT Base styles\n */\n\n/* Root OT object, this is where our CSS reset happens */\n.OT_root,\n.OT_root * {\n  color: #ffffff;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: Arial, Helvetica, sans-serif;\n  vertical-align: baseline;\n}\n\n/**\n * Specific Element Reset\n */\n\n.OT_root h1,\n.OT_root h2,\n.OT_root h3,\n.OT_root h4,\n.OT_root h5,\n.OT_root h6 {\n  color: #ffffff;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 100%;\n  font-weight: bold;\n}\n\n.OT_root header {\n\n}\n\n.OT_root footer {\n\n}\n\n.OT_root div {\n\n}\n\n.OT_root section {\n\n}\n\n.OT_root video {\n\n}\n\n.OT_root button {\n\n}\n\n.OT_root strong {\n  font-weight: bold;\n}\n\n.OT_root em {\n  font-style: italic;\n}\n\n.OT_root a,\n.OT_root a:link,\n.OT_root a:visited,\n.OT_root a:hover,\n.OT_root a:active {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.OT_root ul, .OT_root ol {\n  margin: 1em 1em 1em 2em;\n}\n\n.OT_root ol {\n  list-style: decimal outside;\n}\n\n.OT_root ul {\n  list-style: disc outside;\n}\n\n.OT_root dl {\n  margin: 4px;\n}\n\n.OT_root dl dt,\n.OT_root dl dd {\n  float: left;\n  margin: 0;\n  padding: 0;\n}\n\n.OT_root dl dt {\n  clear: left;\n  text-align: right;\n  width: 50px;\n}\n\n.OT_root dl dd {\n  margin-left: 10px;\n}\n\n.OT_root img {\n  border: 0 none;\n}\n\n/* Modal dialog styles */\n\n/* Modal dialog styles */\n\n.OT_dialog-centering {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.OT_dialog-centering-child {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.OT_dialog {\n  position: relative;\n\n  box-sizing: border-box;\n  max-width: 576px;\n  margin-right: auto;\n  margin-left: auto;\n  padding: 36px;\n  text-align: center; /* centers all the inline content */\n\n  background-color: #363636;\n  color: #fff;\n  box-shadow: 2px 4px 6px #999;\n  font-family: 'Didact Gothic', sans-serif;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.OT_dialog * {\n  font-family: inherit;\n  box-sizing: inherit;\n}\n\n.OT_closeButton {\n  color: #999999;\n  cursor: pointer;\n  font-size: 32px;\n  line-height: 36px;\n  position: absolute;\n  right: 18px;\n  top: 0;\n}\n\n.OT_dialog-messages {\n  text-align: center;\n}\n\n.OT_dialog-messages-main {\n  margin-bottom: 36px;\n  line-height: 36px;\n\n  font-weight: 300;\n  font-size: 24px;\n}\n\n.OT_dialog-messages-minor {\n  margin-bottom: 18px;\n\n  font-size: 13px;\n  line-height: 18px;\n  color: #A4A4A4;\n}\n\n.OT_dialog-messages-minor strong {\n  color: #ffffff;\n}\n\n.OT_dialog-actions-card {\n  display: inline-block;\n}\n\n.OT_dialog-button-title {\n  margin-bottom: 18px;\n  line-height: 18px;\n\n  font-weight: 300;\n  text-align: center;\n  font-size: 14px;\n  color: #999999;\n}\n.OT_dialog-button-title label {\n  color: #999999;\n}\n\n.OT_dialog-button-title a,\n.OT_dialog-button-title a:link,\n.OT_dialog-button-title a:active {\n  color: #02A1DE;\n}\n\n.OT_dialog-button-title strong {\n  color: #ffffff;\n  font-weight: 100;\n  display: block;\n}\n\n.OT_dialog-button {\n  display: inline-block;\n\n  margin-bottom: 18px;\n  padding: 0 1em;\n\n  background-color: #1CA3DC;\n  text-align: center;\n  cursor: pointer;\n}\n\n.OT_dialog-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.OT_dialog-button-large {\n  line-height: 36px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n\n  font-weight: 100;\n  font-size: 24px;\n}\n\n.OT_dialog-button-small {\n  line-height: 18px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n\n  background-color: #444444;\n  color: #999999;\n  font-size: 16px;\n}\n\n.OT_dialog-progress-bar {\n  display: inline-block; /* prevents margin collapse */\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 41px;\n\n  border: 1px solid #4E4E4E;\n  height: 8px;\n}\n\n.OT_dialog-progress-bar-fill {\n  height: 100%;\n\n  background-color: #29A4DA;\n}\n\n/* Helpers */\n\n.OT_centered {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin: 0;\n}\n\n.OT_dialog-hidden {\n  display: none;\n}\n\n.OT_dialog-button-block {\n  display: block;\n}\n\n.OT_dialog-no-natural-margin {\n  margin-bottom: 0;\n}\n\n/* Publisher and Subscriber styles */\n\n.OT_publisher, .OT_subscriber {\n  position: relative;\n  min-width: 48px;\n  min-height: 48px;\n}\n\n.OT_publisher .OT_video-element,\n.OT_subscriber .OT_video-element {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  transform-origin: 0 0;\n}\n\n/* Styles that are applied when the video element should be mirrored */\n.OT_publisher.OT_mirrored .OT_video-element {\n  transform: scale(-1, 1);\n  transform-origin: 50% 50%;\n}\n\n.OT_subscriber_error {\n  background-color: #000;\n  color: #fff;\n  text-align: center;\n}\n\n.OT_subscriber_error > p {\n  padding: 20px;\n}\n\n/* The publisher/subscriber name/mute background */\n.OT_publisher .OT_bar,\n.OT_subscriber .OT_bar,\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name,\n.OT_publisher .OT_archiving,\n.OT_subscriber .OT_archiving,\n.OT_publisher .OT_archiving-status,\n.OT_subscriber .OT_archiving-status,\n.OT_publisher .OT_archiving-light-box,\n.OT_subscriber .OT_archiving-light-box {\n  -ms-box-sizing: border-box;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: block;\n  height: 34px;\n  position: absolute;\n}\n\n.OT_publisher .OT_bar,\n.OT_subscriber .OT_bar {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.OT_publisher .OT_edge-bar-item,\n.OT_subscriber .OT_edge-bar-item {\n  z-index: 1; /* required to get audio level meter underneath */\n}\n\n/* The publisher/subscriber name panel/archiving status bar */\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name {\n  background-color: transparent;\n  color: #ffffff;\n  font-size: 15px;\n  line-height: 34px;\n  font-weight: normal;\n  padding: 0 4px 0 36px;\n  letter-spacing: normal;\n}\n\n.OT_publisher .OT_archiving-status,\n.OT_subscriber .OT_archiving-status {\n  background: rgba(0, 0, 0, 0.4);\n  top: auto;\n  bottom: 0;\n  left: 34px;\n  padding: 0 4px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 15px;\n  line-height: 34px;\n  font-weight: normal;\n  letter-spacing: normal;\n}\n\n.OT_micro .OT_archiving-status,\n.OT_micro:hover .OT_archiving-status,\n.OT_mini .OT_archiving-status,\n.OT_mini:hover .OT_archiving-status {\n  display: none;\n}\n\n.OT_publisher .OT_archiving-light-box,\n.OT_subscriber .OT_archiving-light-box {\n  background: rgba(0, 0, 0, 0.4);\n  top: auto;\n  bottom: 0;\n  right: auto;\n  width: 34px;\n  height: 34px;\n}\n\n.OT_archiving-light {\n  width: 7px;\n  height: 7px;\n  border-radius: 30px;\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  background-color: #575757;\n  box-shadow: 0 0 5px 1px #575757;\n}\n\n.OT_archiving-light.OT_active {\n  background-color: #970d13;\n  -webkit-animation: OT_pulse 1.3s ease-in;\n  -moz-animation: OT_pulse 1.3s ease-in;\n  -webkit-animation: OT_pulse 1.3s ease-in;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -webkit-animation-iteration-count: infinite;\n}\n\n.OT_mini .OT_bar,\n.OT_bar.OT_mode-mini,\n.OT_bar.OT_mode-mini-auto {\n  bottom: 0;\n  height: auto;\n}\n\n.OT_mini .OT_name.OT_mode-off,\n.OT_mini .OT_name.OT_mode-on,\n.OT_mini .OT_name.OT_mode-auto,\n.OT_mini:hover .OT_name.OT_mode-auto {\n  display: none;\n}\n\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name {\n    left: 10px;\n    right: 37px;\n    height: 34px;\n    padding-left: 0;\n}\n\n.OT_publisher .OT_mute,\n.OT_subscriber .OT_mute {\n    border: none;\n    cursor: pointer;\n    display: block;\n    position: absolute;\n    text-align: center;\n    text-indent: -9999em;\n    background-color: transparent;\n    background-repeat: no-repeat;\n}\n\n.OT_publisher .OT_mute,\n.OT_subscriber .OT_mute {\n  right: 0;\n  top: 0;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  height: 36px;\n  width: 37px;\n}\n\n.OT_mini .OT_mute,\n.OT_publisher.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold,\n.OT_subscriber.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold {\n  top: 50%;\n  left: 50%;\n  right: auto;\n  margin-top: -18px;\n  margin-left: -18.5px;\n  border-left: none;\n}\n\n.OT_publisher .OT_mute {\n  background-image: url(../images/rtc/mic-on.png);\n  background-position: 9px 5px;\n}\n\n.OT_publisher .OT_mute.OT_active {\n  background-image: url(../images/rtc/mic-off.png);\n  background-position: 9px 4px;\n}\n\n.OT_subscriber .OT_mute {\n  background-image: url(../images/rtc/speaker-on.png);\n  background-position: 8px 7px;\n}\n\n.OT_subscriber .OT_mute.OT_active {\n  background-image: url(../images/rtc/speaker-off.png);\n  background-position: 7px 7px;\n}\n\n/**\n * Styles for display modes\n *\n * Note: It's important that these completely control the display and opacity\n * attributes, no other selectors should atempt to change them.\n */\n\n/* Default display mode transitions for various chrome elements */\n.OT_publisher .OT_edge-bar-item,\n.OT_subscriber .OT_edge-bar-item {\n  transition-property: top, bottom, opacity;\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_mode-off,\n.OT_publisher .OT_edge-bar-item.OT_mode-auto,\n.OT_subscriber .OT_edge-bar-item.OT_mode-auto,\n.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,\n.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {\n  top: -25px;\n  opacity: 0;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_mode-off {\n  display: none;\n}\n\n.OT_mini .OT_mute.OT_mode-auto,\n.OT_publisher .OT_mute.OT_mode-mini-auto,\n.OT_subscriber .OT_mute.OT_mode-mini-auto {\n  top: 50%;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto {\n  top: auto;\n  bottom: -25px;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-on,\n.OT_subscriber .OT_edge-bar-item.OT_mode-on,\n.OT_publisher .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,\n.OT_subscriber .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,\n.OT_publisher:hover .OT_edge-bar-item.OT_mode-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_mode-auto,\n.OT_publisher:hover .OT_edge-bar-item.OT_mode-mini-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_mode-mini-auto {\n  top: 0;\n  opacity: 1;\n}\n\n.OT_mini .OT_mute.OT_mode-on,\n.OT_mini:hover .OT_mute.OT_mode-auto,\n.OT_mute.OT_mode-mini,\n.OT_root:hover .OT_mute.OT_mode-mini-auto {\n  top: 50%;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,\n.OT_publisher:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto {\n  top: auto;\n  bottom: 0;\n  opacity: 1;\n}\n\n\n/* Contains the video element, used to fix video letter-boxing */\n.OT_widget-container {\n  position: absolute;\n  background: linear-gradient(60.08deg, #333333 0%, #1A1A1A 100%);\n  overflow: hidden;\n}\n\n.OT_hidden-audio {\n  position: absolute !important;\n  height: 1px !important;\n  width: 1px !important;\n}\n\n/* Load animation */\n.OT_root .OT_video-loading {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: none;\n\n  background-color: rgba(0, 0, 0, .75);\n}\n\n.OT_root .OT_video-loading .OT_video-loading-spinner {\n  background: url('../images/rtc/loader.svg') no-repeat;\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  left: 50%;\n  top: 50%;\n  margin-left: -16px;\n  margin-top: -16px;\n  animation: OT_spin 2s linear infinite;\n}\n@keyframes OT_spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.OT_publisher.OT_loading .OT_video-loading,\n.OT_subscriber.OT_loading .OT_video-loading {\n  display: block;\n}\n\n.OT_publisher.OT_loading .OT_video-element,\n.OT_subscriber.OT_loading .OT_video-element {\n  /*display: none;*/\n}\n\n.OT_video-centering {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.OT_video-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.OT_video-poster {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: none;\n\n  opacity: 1.0;\n\n  background-repeat: no-repeat;\n  background-image: url(../images/rtc/audioonly-figma-silhouette.svg);\n  background-size: auto 55%;\n}\n\n.OT_fit-mode-cover .OT_video-element {\n  object-fit: cover;\n}\n\n/* Workaround for iOS freezing issue when cropping videos */\n/* https://bugs.webkit.org/show_bug.cgi?id=176439 */\n@media only screen\n  and (orientation: portrait) {\n  .OT_subscriber.OT_ForceContain.OT_fit-mode-cover .OT_video-element {\n    object-fit: contain !important;\n  }\n}\n\n.OT_fit-mode-contain .OT_video-element {\n  object-fit: contain;\n}\n\n.OT_fit-mode-cover .OT_video-poster {\n  background-position: center;\n}\n\n.OT_fit-mode-contain .OT_video-poster {\n  background-position: center;\n}\n\n.OT_audio-level-meter {\n  position: absolute;\n  width: 25%;\n  max-width: 224px;\n  min-width: 21px;\n  top: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.OT_audio-level-meter:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_audio-level-meter__audio-only-img {\n  position: absolute;\n  top: 22%;\n  right: 15%;\n  width: 40%;\n\n  opacity: .7;\n\n  background: url(../images/rtc/audioonly-headset.svg) no-repeat center;\n}\n\n.OT_audio-level-meter__audio-only-img:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_audio-level-meter__value {\n  will-change: transform;\n  position: absolute;\n  top: -100%;\n  right: -100%;\n  width: 200%;\n  height: 200%;\n  transform: scale(0);\n  border-radius: 50%;\n  background-image: radial-gradient(circle, rgba(151, 206, 0, 1) 0%, rgba(151, 206, 0, 0) 100%);\n}\n\n.OT_audio-level-meter.OT_mode-off {\n    display: none;\n}\n\n.OT_audio-level-meter.OT_mode-on,\n.OT_audio-only .OT_audio-level-meter.OT_mode-auto {\n  display: block;\n}\n\n.OT_audio-only.OT_publisher .OT_video-element,\n.OT_audio-only.OT_subscriber .OT_video-element {\n  display: none;\n}\n\n\n.OT_video-disabled-indicator {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 3px;\n  right: 3px;\n}\n\n.OT_video-disabled {\n  background-image: url(../images/rtc/video-disabled.png);\n  background-size: 33px auto;\n}\n\n.OT_video-disabled-warning {\n  background-image: url(../images/rtc/video-disabled-warning.png);\n  background-size: 33px auto;\n}\n\n.OT_video-disabled-indicator.OT_active {\n  display: block;\n}\n\n.OT_audio-blocked-indicator {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.OT_audio-blocked {\n  background-image: url(../images/rtc/audio-off-background.svg);\n  background-size: 90px auto;\n}\n\n.OT_container-audio-blocked {\n  cursor: pointer;\n}\n\n.OT_container-audio-blocked.OT_mini .OT_edge-bar-item {\n  display: none;\n}\n\n.OT_container-audio-blocked .OT_mute {\n  display: none;\n}\n\n.OT_audio-blocked-indicator.OT_active {\n  display: block;\n}\n\n.OT_video-unsupported {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(../images/rtc/video-off.svg);\n  background-size: 58px auto;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin-top: -30px;\n}\n\n.OT_video-unsupported-bar {\n  display: none;\n  position: absolute;\n  width: 192%; /* copy the size of the audio meter bar for symmetry */\n  height: 192%;\n  top: -96% /* half of the size */;\n  left: -96%;\n  border-radius: 50%;\n\n  background-color: rgba(0, 0, 0, .8);\n}\n\n.OT_video-unsupported-img {\n  display: none;\n  position: absolute;\n  top: 11%;\n  left: 15%;\n  width: 70%;\n  opacity: .7;\n  background-image: url(../images/rtc/video-off.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% auto;\n}\n\n.OT_video-unsupported-img:before {\n  /* makes the height of the container 93% of its width (90/97 px) */\n  content: '';\n  display: block;\n  padding-top: 93%;\n}\n\n.OT_video-unsupported-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n  margin-top: 40px;\n}\n\n.OT_video-unsupported.OT_active {\n  display: block;\n}\n\n.OT_mini .OT_video-unsupported,\n.OT_micro .OT_video-unsupported {\n  position: absolute;\n  width: 25%;\n  max-width: 224px;\n  min-width: 21px;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  background: none;\n  bottom: auto;\n  right: auto;\n  margin: auto;\n}\n\n.OT_mini .OT_video-unsupported:before,\n.OT_micro .OT_video-unsupported:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_mini .OT_video-unsupported-bar,\n.OT_micro .OT_video-unsupported-bar,\n.OT_mini .OT_video-unsupported-img,\n.OT_micro .OT_video-unsupported-img {\n  display: block;\n}\n\n.OT_mini .OT_video-unsupported-text,\n.OT_micro .OT_video-unsupported-text {\n  display: none;\n}\n\n.OT_hide-forced {\n  display: none;\n}\n\n.OT_ModalDialog {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 1000;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n#tb_alert {\n  position: fixed;\n  width: 570px;\n  font-family: \"Lucida Grande\", Arial;\n  top: 50%;\n  left: 50%;\n  margin-top: -75px;\n  margin-left: -285px;\n}\n\n#tb_alert * {\n  box-sizing: border-box;\n}\n\n#tb_alert .OT_alert {\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  background-color: #333;\n  position: relative;\n  padding: 30px;\n  overflow: visible;\n  margin-left: 70px;\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n  border-left-color: rgba(255, 255, 255, 0.1);\n\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));\n\n  background-image: -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));\n\n  background-size: 4px 4px;\n  background-position: 0 0, 2px 2px;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n#tb_alert .OT_alert-exclamation {\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n\n  margin: -1px 0;\n\n  font-family: MS Trebuchet;\n  font-weight: bold;\n  font-size: 60px;\n  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);\n\n  color: white;\n  width: 65px;\n  position: absolute;\n  padding: 42px 0;\n  text-align: center;\n  left: -70px;\n  top: 0;\n  bottom: 0;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n\n  border-bottom-color: transparent;\n  border-left: none;\n  border-right: none;\n}\n\n.OT_alert-exclamation {\n  background-color: #9c1408;\n  background-image: linear-gradient(0deg, #dd0c0a 0%, #9c1408 100%);\n}\n\n.OT_alert-exclamation.OT_alert-check {\n  background-color: #0a8a16;\n  background-image: linear-gradient(0deg, #12c722 0%, #0a8a16 100%);\n}\n\n#tb_alert .OT_alert-exclamation:after,\n#tb_alert .OT_alert-exclamation:before {\n  content: \" \";\n  position: absolute;\n  right: -24px;\n  top: 40%;\n  border: 12px solid transparent;\n  border-left-color: #9c1408;\n}\n\n#tb_alert .OT_alert-exclamation.OT_alert-check:after,\n#tb_alert .OT_alert-exclamation.OT_alert-check:before {\n  border-left-color: #0a8a16;\n}\n\n#tb_alert .OT_alert-exclamation:before {\n  border-left-color: #bc3428;\n  top: 39%;\n}\n\n#tb_alert .OT_alert-body {\n  color: #c8c5c5;\n  margin: 0;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);\n  font-size: 14px;\n  line-height: 1.3em;\n}\n\n#tb_alert .continue-text {\n  margin-top: 12px\n}\n\n#tb_alert > * a {\n  color: #a7d8df;\n  text-decoration: none;\n}\n\n#tb_alert .OT_alert-header {\n  font-size: 24px;\n  padding-bottom: 5px;\n  color: #aaa;\n  font-weight: bold;\n  position: relative;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);\n  margin: 0;\n}\n\n#tb_alert .OT_alert-header::before {\n  content: attr(data-text);\n  position: absolute;\n  left: 0;\n  color: white;\n  -webkit-mask-image: -webkit-gradient(\n    linear,\n    left top, left bottom,\n    from(rgba(0, 0, 0, 1)),\n    color-stop(60%, rgba(0, 0, 0, 0)),\n    to(rgba(0, 0, 0, 0))\n  );\n}\n\n#tb_alert .OT_alert-close-button {\n  position: absolute;\n  right: 8px;\n  top: 5px;\n  background-color: #000;\n  color: #666;\n  border: none;\n  font-size: 20px;\n  /** Hack to bring it up to the proper line top */\n  line-height: 14px;\n  padding: 0;\n  padding-bottom: 3px;\n  cursor: pointer;\n}\n\n#tb_alert #section-mobile-unsupported-install,\n#tb_alert #section-mobile-supported-install,\n#tb_alert #section-mobile-upgrade-install {\n  width: 200px;\n  top: 0px;\n  left: 25%;\n  margin-top: 0;\n  margin-left: 0;\n}\n\n@media all and (max-height: 300px) {\n  #tb_alert {\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    margin-left: 0;\n    margin-top: 0;\n  }\n  #tb_alert #section-mobile-unsupported-install,\n  #tb_alert #section-mobile-supported-install,\n  #tb_alert #section-mobile-upgrade-install {\n    margin-left: 0;\n    margin-top: 10px;\n    left: 0;\n  }\n}\n\n#tb_alert #section-supported-install,\n#tb_alert #section-unsupported-install,\n#tb_alert #section-upgrade-install,\n#tb_alert #section-mobile-unsupported-install,\n#tb_alert #section-mobile-supported-install,\n#tb_alert #section-mobile-upgrade-install {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
